export var version = '3.0.0-alpha.40';